import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
import { AdminComponent } from './admin.component';
import {routing} from './admin.routing';
import {ManageUsersModule} from './manage-users/manage-users.module';
import {ConfigModule} from './config/config.module';
import {AdminService} from './admin.service';




@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    routing,
    ManageUsersModule,
    ConfigModule,

  ],
  declarations: [AdminComponent],
  providers:[
    AdminService
  ]
})
export class AdminModule { }



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/admin/admin.module.ts